import { Label } from "@progress/kendo-react-labels";
import {
  TreeView,
  TreeViewExpandChangeEvent,
  TreeViewItemClickEvent,
} from "@progress/kendo-react-treeview";
import { useEffect, useState } from "react";
import { Company } from "../Company";
import { Configuration } from "./Configuration";
import { ConfigurationsGrid } from ".";

interface IConfigurationsGridByCompanyProps {
  companies: Company[];
  companyId: number;
  data: Configuration[];
  margins: any[];
  marginField: string;
  childMarginField?: string;
  onChange: () => void;
}

export const ConfigurationsGridByCompany = (props: IConfigurationsGridByCompanyProps) => {
  const { companies, companyId, data } = props;

  const [companyTree, setCompanyTree] = useState<any[]>([]);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [childCompanyIds, setChildCompanyIds] = useState<number[]>([]);

  const getChildCompanies = (id: number) =>
    companies?.filter((c) => c.parentCompanyId === id) || [];

  const addTreeNode = (cur: any[], company: any) => {
    let childNodes: any[] = [];
    const childCompanies = getChildCompanies(company.id);
    childCompanies.forEach((c: any) => addTreeNode(childNodes, c));

    const item = {
      id: company.id,
      text: company.name,
      items: childNodes,
      expanded: company.id === companyId,
      selected: company.id === companyId,
    };

    cur.push(item);
    if (item.selected) setSelectedItem(item);
  };

  useEffect(() => {
    if (!companies) return;

    let tree: any[] = [];
    companies.filter((c) => c.id === companyId).forEach((c) => addTreeNode(tree, c));
    setCompanyTree(tree);

    setChildCompanyIds(getChildCompanies(companyId).map((c) => c.id));
  }, [companies, companyId]);

  const onExpandChange = (event: TreeViewExpandChangeEvent) => {
    event.item.expanded = !event.item.expanded;
    setCompanyTree([...companyTree]);
  };

  const onCompanySelected = (event: TreeViewItemClickEvent) => {
    if (selectedItem) selectedItem.selected = false;

    event.item.selected = true;
    setSelectedItem(event.item);
    setCompanyTree([...companyTree]);
  };

  return (
    <div style={{ display: "flex" }}>
      <div style={{ flexBasis: "30%" }}>
        <TreeView
          data={companyTree}
          expandIcons={true}
          onExpandChange={onExpandChange}
          onItemClick={onCompanySelected}
        />
      </div>
      <div>
        <Label style={{ fontWeight: "bolder" }}>Products for {selectedItem?.text}</Label>
        <ConfigurationsGrid
          {...props}
          data={data.filter((c) => c.companyId === selectedItem?.id)}
          childCompanyIds={childCompanyIds}
        />
      </div>
    </div>
  );
};
